import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../../../../components/Button';
import SearchHeader from '../../../../components/SearchHeader';
import LoadMask from '../../../../components/LoadMask';
import AdminTable from '../../components/AdminTable';
import TagList from '../../components/AdminTable/TagList';
import Brand from '../../components/AdminTable/Brand';
import AddCompanyModal from './AddCompanyModal';
import EditCompanyModal from './EditCompanyModal';
import NotificationSettingsModal from './NotificationSettingsModal';

import { fetchCompanies } from '../../../../redux/admin-companies';
import { getCompaniesUI } from '../../../../redux/selectors';
import { BRANCHES_OPTIONS_COMPANY } from '../../shared/static-options';
import { formatCpfAndCnpj } from '../../../../utils/parsers-formatters';

import './styles.css';


const tableColumnNames = {
  LOGO: 'logo',
  CORPORATE_NAME: 'corporateName',
  COMPANY_CNPJ: 'companyCNPJ',
  DIVISION: 'division',
  EDIT: 'edit',
  NOTIFICATION_SETTINGS: 'notificationSettings',
};

class AdminCompanies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCompanyModal: {
        visible: false,
      },
      editCompanyModal: {
        visible: false,
        companyData: null,
      },
      notificationSettingsModal: {
        visible: false,
        companyData: {
          corporateName: '',
          id: null,
        },
      },
      tableHeaders: [
        {
          name: tableColumnNames.LOGO,
          label: 'Marca',
        },
        {
          name: tableColumnNames.CORPORATE_NAME,
          label: 'Razão Social',
          boldPrimary: true,
        },
        {
          name: tableColumnNames.COMPANY_CNPJ,
          label: 'CNPJ/CPF',
        },
        {
          name: tableColumnNames.DIVISION,
          label: 'Luft',
        },
      ],
      tableActions: [
        {
          name: tableColumnNames.EDIT,
          label: 'Editar',
          iconName: 'mode_edit',
          actionFn: this._toggleEditCompanyModal,
        },
        {
          name: tableColumnNames.NOTIFICATION_SETTINGS,
          label: 'Notificações',
          iconName: 'notifications',
          actionFn: this._toggleNotificationSettingsModal,
        },
      ],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchCompanies());
  }

  _onSearch = (searchValue) => {
    const { dispatch } = this.props;

    // Workaround to enable search for branch column
    const branchMatched = BRANCHES_OPTIONS_COMPANY.find(branch =>
      branch.label.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));

    let searchVal = searchValue;
    if (branchMatched) searchVal = branchMatched.id;

    dispatch(fetchCompanies(searchVal));
  }

  _onRenderCell = (column, value) => {
    switch (column) {
      case tableColumnNames.LOGO: {
        return value ? <Brand logoBase64={value} /> : '-';
      }
      case tableColumnNames.COMPANY_CNPJ: {
        const tagData = value ? value.map((el) => { return { name: formatCpfAndCnpj(el.cnpj) }; }) : [];
        return <TagList tagData={tagData} />;
      }
      case tableColumnNames.DIVISION: {
        const branchOption = BRANCHES_OPTIONS_COMPANY.filter(option => option.id === value);
        return branchOption && branchOption.length > 0 ? branchOption[0].label : '';
      }
      default:
        return value;
    }
  }

  _toggleAddCompanyModal = () => {
    this.setState({
      addCompanyModal: {
        visible: !this.state.addCompanyModal.visible,
      },
    });
  }

  _toggleEditCompanyModal = (companyData) => {
    this.setState({
      editCompanyModal: {
        visible: !this.state.editCompanyModal.visible,
        companyData: companyData || null,
      },
    });
  }

  _toggleNotificationSettingsModal = (companyData) => {
    this.setState({
      notificationSettingsModal: {
        visible: !this.state.notificationSettingsModal.visible,
        companyData,
      },
    });
  }

  _renderBatchEdit = (selectedRows) => {
    if (!selectedRows) return null;

    return (
      <div className="luft-users-edit-multiple">
        <div className="luft-users-edit-multiple-counter">
          <span className="luft-users-edit-multiple-counter-number">{selectedRows.length}</span>
          <span className="luft-users-edit-multiple-counter-label">empresas selecionadas</span>
        </div>
        <div className="luft-users-edit-multiple-buttons">
          <Button
            type="button"
            skin="primary"
            text="ALTERAR LUFT"
            onClick={() => { }}
          />
          <Button
            type="button"
            skin="danger"
            text="REMOVER SELECIONADOS"
            onClick={() => { }}
          />
        </div>
      </div>
    );
  }

  render() {
    const { ui, companies } = this.props;
    const {
      tableHeaders,
      addCompanyModal,
      editCompanyModal,
      tableActions,
      notificationSettingsModal,
    } = this.state;

    return (
      <div>
        <SearchHeader
          onSearch={this._onSearch}
          right={() => (
            <Button
              skin="primary"
              text="ADICIONAR EMPRESA"
              onClick={this._toggleAddCompanyModal}
            />
          )}
        />
        <AdminTable
          errorMessage={ui.error}
          headers={tableHeaders}
          data={companies}
          actions={tableActions}
          renderBatchEdit={this._renderBatchEdit}
          onRenderCell={this._onRenderCell}
        />
        {
          addCompanyModal.visible &&
          <AddCompanyModal
            onDismiss={this._toggleAddCompanyModal}
          />
        }
        {
          editCompanyModal.visible &&
          <EditCompanyModal
            companyData={editCompanyModal.companyData}
            onDismiss={this._toggleEditCompanyModal}
          />
        }
        {
          notificationSettingsModal.visible &&
          <NotificationSettingsModal
            onDismiss={this._toggleNotificationSettingsModal}
            companyData={notificationSettingsModal.companyData}
          />
        }
        {
          ui.isFetching &&
          <LoadMask text="Carregando..." />
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ui: getCompaniesUI(state),
    companies: state.adminCompanies.companies.data,
  };
}

export default connect(mapStateToProps)(AdminCompanies);
